import namespace from './namespace';

export default {    
    [namespace.state.CONFIGURATION]: {},
    [namespace.state.VIEW_NOTIFICATION]: {kind: "NONE", text: ""},
    [namespace.state.WAITING_FOR_RESPONSE]: false,
    [namespace.state.LOADING_MESSAGE]: ""
};


// WEBPACK FOOTER //
// ./src/store/modules/smtp/state.js